
import Vue from "vue";
import $ from "jquery";
import axios from "axios";
import filters from "@/filters";
import Component from "vue-class-component";
import { Action, State } from "vuex-class";

import { SchoolModel } from "@/models/academy.model";
import { CoachmarkModel } from "@/models/coachmark.model";
import { isUniversity } from "@/functions/userinterface.function";

import CandidateService from "@/services/candidate.service";
import ImportFile from "@/components/input/ImportFile.vue";
import CoachMark from "@/components/coachmark/Coachmark.vue";
import UploadedFile from "@/components/candidate/UploadedFile.vue";
import UploadProgress from "@/components/candidate/UploadProgress.vue";

@Component({
  filters,
  components: {
    UploadProgress,
    ImportFile,
    UploadedFile,
    CoachMark,
  },
})
export default class SendInvitation extends Vue {
  /* VUEX */

  /* ACTIONS */
  @Action("actionSelectCandidateInactive", { namespace: "candidate" })
  private actionSelectCandidateInactive: any;
  @Action("actionSelectCoachmark", { namespace: "coachmark" })
  private actionSelectCoachmark: any;
  @Action("actionUpdateCoachmark", { namespace: "coachmark" })
  private actionUpdateCoachmark: any;

  /* STATE */
  @State("locale")
  private locale: any;
  @State("school", { namespace: "academy" })
  private school: SchoolModel;
  @State("coachmark_data", { namespace: "coachmark" })
  private coachmark_data: CoachmarkModel;

  /* INITIALIZATION */
  private formFile: string = "file/Format Data Import Candidate-v2.xlsx";
  private isDownload: boolean = false;
  private files: any = null;
  private queueUploadProgress: any[] = [];
  private array_uploaded: any[] = [];
  private array_import_failed: any[] = [];
  private array_import_failed_pagination: any[] = [];
  private pageSize: number = 2;
  private activeIndex: number = 0;

  private serviceCandidate: CandidateService = new CandidateService();

  private get showCoachMarkSendInvitation() {
    // Old
    // const coachmark_sendinvitation = localStorage.getItem(
    //   "coachmark_sendinvitation"
    // );

    // New
    const coachmark_sendinvitation = this.coachmark_data.coachmark_sendinvitation;

    return !coachmark_sendinvitation;
  }

  private get getImageStep() {
    const imgSchoolEN = require("@/assets/images/school/shape_uploaddata_school_en.svg");
    const imgSchoolID = require("@/assets/images/school/shape_uploaddata_school_id.svg");
    const imgUniversityEN = require("@/assets/images/school/shape_uploaddata_university_en.svg");
    const imgUniversityID = require("@/assets/images/school/shape_uploaddata_university_id.svg");

    if (isUniversity(this.school.school_type)) {
      if (this.locale === 'id') {
        return imgUniversityID;
      }
      return imgUniversityEN;
    } else {
      if (this.locale === 'id') {
        return imgSchoolID;
      }
      return imgSchoolEN;
    }
  }

  private get wordingInviteStudent() {
    if (isUniversity(this.school.school_type)) {
      return this.$i18n.t("invite_student_2");
    }

    return this.$i18n.t("invite_student");
  }

  private get wordingInviteStudentDesc() {
    if (isUniversity(this.school.school_type)) {
      return this.$i18n.t("easily_send_invitation_2");
    }

    return this.$i18n.t("easily_send_invitation");
  }

  private get wordingRegisteredStudentDesc() {
    if (isUniversity(this.school.school_type)) {
      return this.$i18n.t("registered_student_alumni_desc_2");
    }

    return this.$i18n.t("registered_student_alumni_desc");
  }

  private get wordingImportDataDesc() {
    if (isUniversity(this.school.school_type)) {
      return this.$i18n.t("new_import_data_desc_2");
    }

    return this.$i18n.t("new_import_data_desc");
  }

  private get wordingStudentID() {
    if (isUniversity(this.school.school_type)) {
      return this.$i18n.t("student_id_nisn_2");
    }

    return this.$i18n.t("student_id_nisn");
  }

  private get steps() {
    return [
      {
        target: "ContainerButtonDownload",
        placement: "top",
        title: this.$t("coachmark_title_invitation1"),
        content: this.$t("coachmark_desc_invitation1"),
      },
      {
        target: "ContainerButtonUpload",
        placement: "top",
        title: this.$t("coachmark_title_invitation2"),
        content: this.$t("coachmark_desc_invitation2"),
      },
    ];
  }

  private created() {
    if (this.showCoachMarkSendInvitation) {
      window.scrollTo(0, document.body.scrollHeight - 900);
    }
    this.clickPage(1);
  }

  private mounted() {
    this.actionSelectCoachmark({
      success: () => {
        if (!this.showCoachMarkSendInvitation) $(".overlayCoachMark").remove();
      }
    });
  }

  /* METHODS */
  private onPrevCoachMark() {
    this.activeIndex--;
    $(".overlayCoachMark").remove();
  }

  private onNextCoachMark() {
    this.activeIndex++;
    $(".overlayCoachMark").remove();
    if (this.activeIndex == 1) {
      // Old
      // localStorage.setItem("coachmark_sendinvitation", "done");

      // New
      this.coachmark_data.coachmark_sendinvitation = true;
      this.actionUpdateCoachmark({
        success: () => {
          this.actionSelectCoachmark();
        },
      });
    }
  }

  /**
   * https://developerx.atlassian.net/browse/CS-5342
   *
   * Created at : 14 January 2022           Updated at : 14 January 2022
   * Created by : Risman Abdilah            Updated by : Risman Abdilah
   *
   * Version 1.0.0
   */
  private onHideCoachMark(lastStep?: number) {
    if (lastStep) {
      this.activeIndex = lastStep + 1;
    }
    $(".overlayCoachMark").remove();
    // Old
    // localStorage.setItem("coachmark_sendinvitation", "done");

    // New
    this.coachmark_data.coachmark_sendinvitation = true;
    this.actionUpdateCoachmark({
      success: () => {
        this.actionSelectCoachmark();
      },
    });
  }

  private resetUpload() {
    this.queueUploadProgress = new Array<any>();
    this.array_uploaded = new Array<any>();
    this.array_import_failed = new Array<any>();
    this.array_import_failed_pagination = new Array<any>();
  }

  private clickPage(page: number) {
    this.array_import_failed_pagination.splice(0);
    for (
      let i = (page - 1) * this.pageSize;
      i < (page - 1) * this.pageSize + this.pageSize;
      i++
    ) {
      if (i === this.array_import_failed.length) {
        break;
      }
      this.array_import_failed_pagination.push(this.array_import_failed[i]);
    }
  }

  private uploadProgress = (unique: number) => (progress: any) => {
    const percentage = Math.floor((progress.loaded * 100) / progress.total);
    $(`#${unique}`).find("progress").val(percentage);
  };

  private onChangeFile() {
    this.resetUpload();

    if (this.files.size > 0) {
      const unique = new Date().getTime();
      const params = new FormData();

      params.append("import_file", this.files);
      // params.append('unique', String(unique));

      const CancelToken = axios.CancelToken;
      let cancel = null;

      const config = {
        cancelToken: new CancelToken(function executor(c) {
          cancel = c;
        }),
        onUploadProgress: this.uploadProgress(unique),
      };

      this.serviceCandidate
        .serviceImportCandidate(params, config)
        .then((response: any) => {
          if (response) {
            this.array_uploaded.push({ file: this.files, data: response.data });
            $(`#${unique}`).remove();
            if (response.data.success) {
              this.isDownload = true;
              this.actionSelectCandidateInactive();
            }
            if (response.data.partial_error.length !== 0) {
              this.array_import_failed = response.data.partial_error;
              this.clickPage(1);
            }
          }
        });

      this.queueUploadProgress.push({
        file: this.files,
        unique,
        cancel,
      });
    }
    (this.$refs.fileImport as any).clear();
  }

  private getTranslation(val: any) {
    if (this.locale == "en") {
      return val["en"];
    }
    return val["id"];
  }
}
